module.exports = __webpack_public_path__ + "img/medical-hero-illustration.ae548b71.png";